import { format } from 'owa-strings';
import { ITEM_URL } from '../utils/constants';
import { ItemResponse } from 'mini-bx-user-custom-properties';
import { makeSDSNetworkCall } from './makeSDSNetworkCall';

export async function getSDSCollectionItemIdUsingItemClass(
    collectionName: string,
    itemClass: string
): Promise<string | null> {
    const itemsResponse = await makeSDSNetworkCall(format(ITEM_URL, collectionName), 'GET');
    if (itemsResponse?.value) {
        return (itemsResponse.value as ItemResponse[]).find(item => item.ItemClass === itemClass)
            ?.Id;
    }
    return null;
}
